import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { PublicService } from '../../../shared/services/public/public.service';

@Component({
  selector: 'app-contact-info',
  standalone: true,
  imports: [CommonModule, InputTextModule, TextareaModule, ButtonModule,ReactiveFormsModule],
  templateUrl: './contact-info.component.html',
  styleUrl: './contact-info.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ContactInfoComponent {
  contactForm: FormGroup;
  isSubmitting = false;
  contactInfo = {
    title: 'Contact Info',
    subtitle: 'Need any help? ',
    description: 'Give us a call or send us a message.',
    address: 'P.O. Box 420, Purcellville, VA, 20134',
    phone: '+1 571-410-5811',
    emails: ['support@claddedglass.com', 'info@claddedglass.com'],
    socialLinks: [
      { icon: 'pi pi-twitter', link: 'https://twitter.com', class: 'twitter' },
      { icon: 'pi pi-youtube', link: 'https://youtube.com', class: 'youtube' },
      {
        icon: 'pi pi-linkedin',
        link: 'https://linkedin.com',
        class: 'linkedin',
      },
    ],
  };
  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private publicService: PublicService
  ) {
    // Initialize the form
    this.contactForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', Validators.required],
      message: ['', Validators.required],
    });
  }
  async onSubmit() {
    if (this.contactForm.valid) {
      this.isSubmitting = true;
      const formData = {
        ...this.contactForm.value,
        submittedAt: new Date().toISOString(),
      };

      try {
        await this.publicService.saveContactInfo();
        this.toastr.success('Message sent successfully!', 'Success');
        this.contactForm.reset();
      } catch (error) {
        console.error('Error adding data:', error);
        this.toastr.error('An error occurred while sending the message.', 'Error');
      } finally {
        this.isSubmitting = false;
      }
    } else {
      this.toastr.error('Please fill out all required fields.', 'Error');
    }
  }

}
